import { ReactNode, useContext } from "react";
import Page from "../../formatting/Page";
import PageCard from "../../formatting/PageCard";
import { TitleSection } from "../../formatting/CardSection";
import { useDocumentTitle, TITLE_POSTFIX } from "../../shared/DocumentTitle";
import { CreateContractContext } from "./CreateContract";
import CreateContractForm from "./CreateContractForm";
import StaticPage from "../../static-pages/StaticPage";
import Main from "../../Main";
import { ContractType } from "../model/ContractViewModel";
import { useParams } from "react-router";
import NotFoundScreen from "../../shared/error/NotFoundScreen";
import CarryingImg from "../landing/illustrations/woman_carrying_car_above_head_landingpage_284x227.svg";
import styled from "styled-components";
import { ContractTypeKey, getContractType } from "./ContractTypeName";

export interface CreateContractPageParams {
  type: ContractTypeKey;
}

const CreateCard = styled(PageCard)``;
const Illustration = styled.img`
  display: block;
  margin: ${({ theme }) => theme.spacing.space32} 0;
`;

export function CreateContractPageContent({
  contractType,
  title,
  children,
}: {
  contractType: ContractType;
  title: string;
  children?: ReactNode;
}) {
  const createContractContext = useContext(CreateContractContext);
  if (!createContractContext) {
    throw new Error("No CreateContractContext found!");
  }
  const { create } = createContractContext;
  useDocumentTitle(`${title} ${TITLE_POSTFIX}`);

  return (
    <Main>
      <StaticPage footer>
        <Page>
          <CreateCard back="/">
            <Illustration src={CarryingImg} alt="" width="284" height="227" />
            <TitleSection title={title}>
              {children}
              <CreateContractForm
                onSubmit={(request) =>
                  create({
                    ...request,
                    contractType,
                  })
                }
                autoFocus
              />
            </TitleSection>
          </CreateCard>
        </Page>
      </StaticPage>
    </Main>
  );
}

export default function CreateContractPage() {
  const { type: typeName } = useParams<CreateContractPageParams>();
  const contractType = getContractType(typeName);

  if (!contractType) return <NotFoundScreen />;

  return (
    <CreateContractPageContent
      title="Opprett en kjøpekontrakt"
      contractType={contractType}
    />
  );
}
